<template>
    <div class="page">
        <box fill>
            <el-form label-position="right" label-width="80px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="类型" class="EL-Form-Item">
                        <el-select v-model="searchInfo.wisType" placeholder="请选择">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="上限预警" value="10"></el-option>
                            <el-option label="下限预警" value="20"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="日期" class="EL-Form-Item">
                        <el-date-picker v-model="searchInfo.createTime" value-format="yyyy-MM-dd" type="date" placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
              <el-col :lg="5" :xl="5">
                <el-form-item label="供应商" class="EL-Form-Item">
                  <el-select v-model="searchInfo.verdorCode" placeholder="请选择" filterable clearable="clearable">
                    <el-option v-for="(item, index) in vendorList" :key="index" :label="item.svCode + ' - ' + item.vendorName" :value="item.svCode">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :lg="5" :xl="5">
                <el-form-item label="物料类型" class="EL-Form-Item">
                  <el-select v-model="searchInfo.mtType" placeholder="请选择" filterable clearable="clearable"  multiple collapse-tags>
                    <el-option v-for="(item, index) in mtTypeList" :key="index" :label="item.ddCode+' - '+item.ddName" :value="item.ddCode">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getAuxiMaterialData()">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="resetData()">
                            重置
                        </el-button>
                    </el-form-item>
                </el-col>
            </el-form>
            <el-divider></el-divider>
            <plabel text="安全库存查询">
                <el-button v-authority="'BACK_MENU7_M7_B1'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFile()">导出EXCEL</el-button>
            </plabel>
            <!-- 展示 -->
            <h-table :headerCellStyle="headerCellStyle" style="flex: 1" @pageChange="getAuxiMaterialData" :data="mainData" pagination :nowPage.sync="pagination.pageNum" :pageSize.sync="pagination.pageSize" :total.sync="pagination.total">
                <!-- <el-table-column prop="wisId" label="序号" /> -->
                <el-table-column prop="type" label="类型">
                    <template slot-scope="scope">
                        <span v-if="scope.row.type == 10">仓库</span>
                        <span v-if="scope.row.type == 20">物料</span>
                        <span v-if="scope.row.type != 20 && scope.row.type != 10">{{scope.row.type}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="wisType" label="报警类型">
                    <template slot-scope="scope">
                        <span v-if="scope.row.wisType == 10">超上限</span>
                        <span v-if="scope.row.wisType == 20">超下限</span>
                    </template>
                </el-table-column>
                <el-table-column prop="practicalNumber" label="实际值" />
                <el-table-column prop="wisNumber" label="报警值">
                    <template slot-scope="scope">
                        <span v-if="scope.row.wisType == 10">＞{{scope.row.wisNumber}}</span>
                        <span v-if="scope.row.wisType == 20">＜{{scope.row.wisNumber}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="verdorCode" label="供应商" />
                <el-table-column prop="mtType" label="物料类型" />
                <el-table-column prop="wisContent" label="报警内容" />
                <el-table-column prop="createTime" label="创建时间" />
                <el-table-column prop="updateTime" label="更新时间" />

                <!-- <el-table-column prop="" label="仓库" />
                <el-table-column prop="matCode" label="物料编号" />
                <el-table-column prop="matName" label="物料描述" />
                <el-table-column prop="matQuan" label="数量" />
                <el-table-column prop="" label="最小库存" />
                <el-table-column prop="" label="最大库存" />
                <el-table-column prop="" label="安全库存" />
                <el-table-column prop="" label="报警类型" />
                <el-table-column prop="" label="报警数量" /> -->
            </h-table>
        </box>
    </div>
</template>

<script>
    export default {
        name: "safetyInventory",
        data() {
            return {
                headerCellStyle: () => {
                    return "background-color: #1f5cec";
                },
                form: {},
                //主数据
                mainData: [],
                pagination: {
                    pageNum: 1,
                    pageSize: 50,
                    total: 0,
                },
								searchInfo: {
                    wisType: "",
                    createTime: "",
                    fcCode: localStorage.getItem("fcCode") || "",
                    verdorCode: '',
                    mtType: ''
								},
                taskTab: "0",

                downloadLoading: false, //下载中

                logContent: "", //操作日志-内容
                logRemarks: "", //操作日志-备注
                // 输入框延时加载
                isSetTimeout: null,
                vendorList: [],
                mtTypeList: [],
            };
        },
        watch: {
            searchInfo: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.getAuxiMaterialData(newVal);
                    },1000)
                },
                deep: true,
            },
        },
        methods: {
          async getVerdorList() {
            try {
              const res = await this.$http.request({
                url: "/api/vendor/getVendorAll",
                method: "GET",
                showLoading: true,
                params: {
                  pageNum: 1,
                  pageSize: 999999,
                },
              })
              if (res.status == 100) {
                this.vendorList = res.data.list
              } else {
                this.vendorList = []
              }
            } catch (error) {
              this.vendorList = []
            }
          },
          async getMtTypeList() {
            try {
              const res = await this.$http.request({
                url: "/api/dictData/getDictData",
                method: "GET",
                showLoading: true,
                params: {
                  ddCode: "MDTYPE",
                },
              })
              if (res.status == 100) {
                this.mtTypeList = res.data.list
              } else {
                this.mtTypeList = []
              }
            } catch (error) {
              this.mtTypeList = []
            }
          },
            //获取数据
            getAuxiMaterialData() {
                this.$http
                    .request({
                        url: "/api/inventorySafety/getInventorySafetyAll",
                        method: "GET",
                        params: {
													pageNum: this.pagination.pageNum,
													pageSize: this.pagination.pageSize,
													wisType: this.searchInfo.wisType || null,
													createTime: this.searchInfo.createTime || null,
													fcCode: this.searchInfo.fcCode || null,
                          verdorCode: this.searchInfo.verdorCode || null,
                          mtType: this.searchInfo.mtType.join(',') || null,
												},
                    })
                    .then((resp) => {
                        this.loading--;
                        if (resp.status == 100) {
                            // console.log(resp.data.list);
                            this.mainData = resp.data.list || [];
                            this.pagination.total = resp.data.total;
                        }
                    })
                    .catch((error) => {
                        this.loading--;
                    });
            },
            //重置
            resetData() {
                this.searchInfo = {
                    wisType: "",
                    createTime: "",
                    fcCode: localStorage.getItem("fcCode") || "",
                };
                this.getAuxiMaterialData();
            },

            //表格导出
            downLoadFile() {
                this.downloadLoading = true;
                var paramsObj = {
                    wisType: this.searchInfo.wisType || null,
                    createTime: this.searchInfo.createTime || null,
                    fcCode: this.searchInfo.fcCode,
                    pageNum: 1,
                    pageSize: 999999,
                }

                this.$http.request({
                    url: '/api/inventorySafety/getInventorySafetyAll',
                    method: 'GET',
                    showLoading: true,
                    params: paramsObj
                }).then((resp) => {
                    resp.status == 100 ? this.downLoad(resp.data.list || []) : this.$notify.error({
                        message: '查询失败'
                    });
                })
            },
            downLoad(list) {
                import('@/libs/Export2Excel').then(excel => {
                    list.forEach(function(c) {
                        if (c.wisType == "10") {
                            c['wisType'] = '超上限'
                            c['wisNumber'] = '> ' + c.wisNumber
                        } else if (c.wisType == "20") {
                            c['wisType'] = '超下限'
                            c['wisNumber'] = '< ' + c.wisNumber
                        }

                        if (c.type == "10") {
                            c['type'] = '仓库'
                        } else if (c.type == "20") {
                            c['type'] = '物料'
                        }
                    })
                    const tHeader = ["类型", '报警类型', '实际值', '报警值', '报警内容', '创建时间', '更新时间']
                    const filterVal = ["type", 'wisType', 'practicalNumber', 'wisNumber', 'wisContent', 'createTime', 'updateTime']
                    const data = this.formatJson(filterVal, list)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: '安全库存报表数据'
                    })
                    this.logContent = "导出"
                    this.logRemarks = "wh_inventory_safety：导出安全库存报表数据"
                    this.systemLog();
                    this.downloadLoading = false
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },

            /**
             * 操作日志
             */
            systemLog() {
                let objData = {
                    logType: "安全库存查询",
                    logContent: this.logRemarks || "",
                    //logRemarks: this.logRemarks || "",
                    logUser: localStorage.getItem("user") || "",
                };
                this.$http
                    .request({
                        url: "api/log/insert",
                        method: "POST",
                        data: objData,
                    })
                    .then((resp) => {
                        this.logContent = "";
                        this.logRemarks = "";
                        if (resp.status == 100) {}
                    })
                    .catch((error) => {});
            },


        },
        activated(){
            /* 获取首页的数据 */
            this.getAuxiMaterialData();
            this.getVerdorList();
            this.getMtTypeList();
        },
    };
</script>

<style scoped>
</style>